export enum ResourceType {
  GUIDES = 'guides',
  RAPPORTS = 'rapports',
  REGULATIONS = 'regulations',
  EVENTS = 'events',
  OTHERS = 'others',
}
